/**
 * Phase 5 — Manual Entries Broker (D5.1–D5.4)
 *
 * Submit / list / approve / reject SPPC-approved user variables.
 */
import AxiosManager from '@/utils/AxiosManager'
import Constants from '@/helpers/Constants'

export default class ManualEntriesBroker {
  private static get ax(): AxiosManager {
    return new AxiosManager(Constants.SERVER_URL)
  }

  /**
   * List entries (+ eligible variable catalog). Optional filters.
   */
  public static async list(args: {
    billing_period_id?: number | null
    status?: string | null
  } = {}): Promise<{ entries: any[]; catalog: any[] }> {
    let url = '/get?comp=manual_entries'
    if (args.billing_period_id != null) {
      url += `&billing_period_id=${args.billing_period_id}`
    }
    if (args.status) {
      url += `&status=${encodeURIComponent(args.status)}`
    }
    const res = await ManualEntriesBroker.ax.get(url)
    return {
      entries: res?.entries ?? [],
      catalog: res?.catalog ?? [],
    }
  }

  /**
   * Submit a pending manual entry.
   */
  public static async submit(payload: {
    variable_id: number
    billing_period_id: number
    value?: number | null
    value_text?: string | null
    notes?: string | null
  }): Promise<any> {
    return ManualEntriesBroker.ax.post('/add', {
      ...payload,
      comp: 'manual_entries',
    })
  }

  /**
   * Approve a pending entry (applies to variable_values).
   */
  public static async approve(id: number, notes?: string | null): Promise<any> {
    return ManualEntriesBroker.ax.post('/approve_manual_entry', { id, notes })
  }

  /**
   * Reject a pending entry.
   */
  public static async reject(id: number, notes?: string | null): Promise<any> {
    return ManualEntriesBroker.ax.post('/reject_manual_entry', { id, notes })
  }

  /**
   * Billing periods for the filter / submit dropdown.
   */
  public static async getBillingPeriods(): Promise<any[]> {
    const res = await ManualEntriesBroker.ax.get('/get?comp=billing_periods')
    return res ?? []
  }
}
